var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 12C19.8 12.4 19.4 12.8 19 12.8H6.9L11.5 17.4C11.8 17.7 11.8 18.2 11.5 18.5C11.3 18.7 11.1 18.7 10.9 18.7C10.7 18.7 10.5 18.6 10.3 18.5L4.3 12.5C4.2 12.4 4.2 12.4 4.2 12.3C4.1 12.1 4.1 11.9 4.2 11.7C4.2 11.6 4.3 11.6 4.3 11.5L10.3 5.5C10.6 5.2 11.1 5.2 11.4 5.5C11.7 5.8 11.7 6.3 11.4 6.6L6.8 11.2H19C19.4 11.2 19.8 11.6 19.8 12Z",
    fill: "#1F2938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.f9542279846b04ff0f9b263de7205101.svg";
export { ForwardRef as ReactComponent };